module.exports = __webpack_public_path__ + "img/zhiqing.76350fee.jpeg";